<template>
	<div class="user-container">
		<div class="content-main">
			<div class="title">
				<span>角色管理</span>
			</div>
			<div class="main">
				<div class="main-right" ref="mainRight">
					<div class="search-container">
						<div class="left-buttons">
							<!-- 诊所下拉 -->
							<el-select v-model="selectedClinicId" placeholder="选择诊所" size="mini"
								@change="handleClinicChange">
								<el-option v-if="showAllClinicOption" key="0" label="全部诊所" :value="0"></el-option>
								<el-option v-for="item in clinicOptions" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
							<!-- 搜索框 -->
							<el-input placeholder="用户名 / 昵称" size="mini" v-model="searchValue">
								<i slot="prefix" class="el-input__icon el-icon-Ssearch"></i>
							</el-input>
							<!-- 查询按钮 -->
							<el-button type="primary" :loading="loading" icon="el-icon-Ssearch" size="mini"
								@click="handleSearch">查询</el-button>
						</div>
						<div class="right-buttons">
							<!-- 新增按钮 -->
							<el-tooltip
							  :content="$store.getters.hasPermission('system:role:add') ? '' : '您当前暂无此操作权限，请联系商务或管理员！'" 
							  placement="top" 
							  :disabled="$store.getters.hasPermission('system:role:add')">
							  <el-button 
							    type="success" 
							    size="mini" 
							    :disabled="!$store.getters.hasPermission('system:role:add')" 
							    @click="openAddRoleDialog">
							    新增
							  </el-button>
							</el-tooltip>
							<!-- 刷新按钮 -->
							<el-button :loading="loading" icon="el-icon-refresh" size="mini"
								@click="handleRefresh">刷新</el-button>
						</div>
					</div>

					<div class="table-container">
						<el-table :data="showCheckResult ? [checkResult] : tableData" :header-cell-style="{ 
                background: '#f4f4f4 !important', 
                border: '1px solid #ebeef5',
                color: '#606266',
                fontWeight: 'bold'
              }" :cell-style="{ border: '1px solid #ebeef5' }" border @row-dblclick="handledbRow" style="width: 100%"
							:row-class-name="tableRowClassName" ref="table" v-resize-table>
							<el-table-column prop="clinicId" label="当前诊所" width="120">
								<template slot-scope="{ row }">
									<span>{{ docclinicMap[row.clinicId] || '' }}</span>
								</template>
							</el-table-column>

							<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type"
								:prop="col.prop" :label="col.name" :min-width="columnWidth(col, tableData)"
								show-overflow-tooltip></el-table-column>

							<el-table-column fixed="left" label="序号" type="index" width="60"></el-table-column>

							<el-table-column fixed="right" label="操作" width="148">
								<template slot-scope="scope">
									<div class="action-buttons">
										<el-tooltip
										  :content="$store.getters.hasPermission('system:role:edit') ? '' : '您当前暂无此操作权限，请联系商务或管理员！'" 
										  placement="top" 
										  :disabled="$store.getters.hasPermission('system:role:edit')">
										  <el-button 
										    type="warning" 
										    size="mini" 
										    :disabled="!$store.getters.hasPermission('system:role:edit')" 
										    @click="handleEdit(scope.row)">
										    编辑
										  </el-button>
										</el-tooltip>
										<el-tooltip
										  :content="$store.getters.hasPermission('system:role:remove') ? '' : '您当前暂无此操作权限，请联系商务或管理员！'" 
										  placement="top" 
										  :disabled="$store.getters.hasPermission('system:role:remove')">
										  <el-button 
										    type="danger" 
										    size="mini" 
										    :disabled="!$store.getters.hasPermission('system:role:remove')" 
										    @click="handleDelete(scope.row)">
										    删除
										  </el-button>
										</el-tooltip>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>

					<div class="pagination-container">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="pageNum" :page-sizes="[10, 50, 100]" :page-size="pageSize" :total="totalSize"
							layout="total, sizes, prev, pager, next, jumper" background></el-pagination>
					</div>

					<!-- 新增角色弹窗（美化版） -->
					<el-dialog title="新增角色" top="4vh" :visible.sync="addRoleDialog" width="520px" :before-close="handleClose"
						class="beauty-role-dialog" @open="handleAddDialogOpen" append-to-body>
						<el-form ref="addForm" :model="addForm" :rules="getFormRules()" label-width="90px" size="small">
							<el-form-item label="角色名称" prop="roleName">
								<el-select v-model="addForm.roleName" placeholder="请选择或输入角色名称" filterable
									allow-create clearable style="width: 100%">
									<el-option v-for="item in refundReasons" :key="item.id" :label="item.value"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="当前诊所" prop="clinicId" v-if="shouldShowClinicSelect">
								<el-select v-model="addForm.clinicId" placeholder="请选择诊所" clearable filterable style="width: 100%">
									<el-option v-for="item in clincOptions" :key="item.id" :label="item.label"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="菜单权限" prop="menuId" class="menu-permission-item">
								<div class="menu-tree-wrapper">
									<el-tree :data="MenuData" show-checkbox node-key="id"
										:default-expanded-keys="defaultExpandedKeys" :check-strictly="true"
										@check="handleCheckChange" @node-click="handleNodeClick" ref="tree"
										:props="defaultProps" class="menu-tree"
										:class="{ 'validate-error': hasMenuValidationError }">
									</el-tree>
									<div v-if="hasMenuValidationError" class="menu-error-msg">请至少选择一个菜单权限</div>
								</div>
							</el-form-item>

							<el-form-item label="角色备注">
								<el-input v-model="addForm.remark" type="textarea" :rows="3" placeholder="请输入备注信息" maxlength="200" show-word-limit>
								</el-input>
							</el-form-item>
						</el-form>

						<span slot="footer" class="dialog-footer">
							<el-button @click="addRoleDialog = false" size="small">取 消</el-button>
							<el-button type="primary" :loading="addLoading" @click="addSubmit" size="small">确 定</el-button>
						</span>
					</el-dialog>

					<!-- 修改角色弹窗（美化版） -->
					<el-dialog title="修改角色" :visible.sync="editRoleDialog" width="520px" :before-close="handleClose"
						class="beauty-role-dialog" @open="handleEditDialogOpen" append-to-body>
						<el-form ref="editForm" :model="editForm" :rules="getFormRules()" label-width="90px" size="small">
							<el-form-item label="角色名称" prop="roleName">
								<el-input v-model="editForm.roleName" placeholder="请输入角色名称"></el-input>
							</el-form-item>

							<el-form-item label="当前诊所" prop="clinicId" v-if="shouldShowClinicSelect">
								<el-select v-model="editForm.clinicId" placeholder="请选择诊所" clearable filterable style="width: 100%">
									<el-option v-for="item in clincOptions" :key="item.id" :label="item.label"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="菜单权限" prop="menuId" class="menu-permission-item">
								<div class="menu-tree-wrapper">
									<el-tree :data="MenuData" show-checkbox node-key="id"
										:default-expanded-keys="defaultExpandedKeys" :check-strictly="true"
										@check="handleCheckChange" @node-click="handleNodeClick" ref="tree"
										:props="defaultProps" class="menu-tree"
										:class="{ 'validate-error': hasMenuValidationError }">
									</el-tree>
									<div v-if="hasMenuValidationError" class="menu-error-msg">请至少选择一个菜单权限</div>
								</div>
							</el-form-item>
						</el-form>

						<span slot="footer" class="dialog-footer">
							<el-button @click="editRoleDialog = false" size="small">取 消</el-button>
							<el-button type="primary" :loading="editLoading" @click="editSubmit" size="small">确 定</el-button>
						</span>
					</el-dialog>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import EventBus from '@/untils/event-bus' //EventBus文件路径
	// selfs / sons
	import Pinyin from "@/external/pinyin.js";
	import {
		getAllRole,
		AllMenu,
		editRole,
		roleMenuIds,
		deleteRole,
		addRole,
		roleList,
		roleId,
		checkRole,
		searchUserMenu
	} from "@/api/user.js";
	import {
		docclinic
	} from "@/api/cinic/cinic.js";
	export default {
		// 指令：表格自适应
		directives: {
			resizeTable: {
				inserted(el, binding) {
					const onResize = () => {
						const table = el.querySelector('.el-table__body-wrapper');
						if (table) {
							table.style.overflowX = 'auto';
						}
					};

					onResize();
					window.addEventListener('resize', onResize);

					// 保存事件处理程序以便清理
					el._onResize = onResize;
				},
				unbind(el) {
					window.removeEventListener('resize', el._onResize);
				}
			}
		},
		// 在Vue组件的computed部分添加
		computed: {
			shouldShowClinicSelect() {
				// 从localStorage重新获取用户信息，确保获取的是最新的clinicId
				const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
				return userInfo.clinicId === 0;
			}
		},
		data() {
			return {
				selectedClinicId: '', // 当前选中的诊所ID
				clinicOptions: [], // 诊所选项列表
				// 新增：是否显示全部诊所选项
				showAllClinicOption: false,
				filterText: '',
				searchValue: '',
				selectValue: '',
				uName: '',
				loading: false,
				disabled: false,
				addRoleDialog: false,
				editRoleDialog: false,
				windowWidth: '',
				defaultExpandedKeys: [1], // 默认展开的节点 id
				// 将默认值改为空数组，避免初始干扰
				defaultCheckedKeys: [],  // 原先是 [2]
				editRoleMenuIds: [],  // 存储当前编辑角色的菜单权限ID
				highlightRowId: null, // 用于存储要高亮显示的行的id
				highlightClassName: 'highlight-row', // 高亮行的类名
				pageNum: 1, //当前页currentPage
				pageSize: 10,
				totalSize: 10, //总条数
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				clinicId: null,
				currentEditId: null,
				checkResult: null, // 存储检测结果
				showCheckResult: false, // 是否显示检测结果
				addLoading: false,
				editLoading: false,
				clincOptions: [], // 隶属诊所
				// 添加上下文菜单状态
				contextMenu: {
					visible: false,
					left: 0,
					top: 0,
					node: null
				},
				// 新增：用户菜单数据
				MenuData: [],
				elTree: [{
					label: '宜宾九阵软件科技有限公司',
					path: '',
					title: '',
					icon: 'el-icon-news',
					children: [{
							label: '运维部',
							path: '',
							title: '',
							icon: 'el-icon-news',
							children: [{
									label: '运维一组',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
								{
									label: '运维二组',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
								{
									label: '运维三组',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
							]
						},
						{
							label: '后勤部',
							path: '',
							title: '',
							icon: 'el-icon-news',
							children: [{
									label: '后勤一部',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
								{
									label: '后勤二部',
									path: '',
									title: '',
									icon: 'el-icon-news',
								}
							]
						},
						{
							label: '财务部',
							path: '',
							title: '',
							icon: 'el-icon-news',
							children: [{
									label: '宜宾一部',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
								{
									label: '成都二部',
									path: '',
									title: '',
									icon: 'el-icon-news',
								},
								{
									label: '水富三部',
									path: '',
									title: '',
									icon: 'el-icon-news',
								}
							]
						},
						{
							label: '研发部',
							path: '',
							title: '',
							icon: 'el-icon-news',
							children: [{
									label: '后端',
									path: '',
									title: '',
									icon: 'el-icon-news',
									children: [{
											label: '后端一组',
											path: '',
											title: '',
											icon: 'el-icon-news',
										},
										{
											label: '后端二组',
											path: '',
											title: '',
											icon: 'el-icon-news',
										}
									]
								},
								{
									label: '前端',
									path: '',
									title: '',
									icon: 'el-icon-news',
									children: [{
											label: '前端一组',
											path: '',
											title: '',
											icon: 'el-icon-news',
										},
										{
											label: '前端二组',
											path: '',
											title: '',
											icon: 'el-icon-news',
										}
									]
								},
								{
									label: '设计',
									path: '',
									title: '',
									icon: 'el-icon-news',
									children: [{
											label: 'UI一部',
											path: '',
											title: '',
											icon: 'el-icon-news',
										},
										{
											label: '平面二部',
											path: '',
											title: '',
											icon: 'el-icon-news',
										}
									]
								},
							]
						}
					],
				}],
				options: [{ id:1,value: '可用',label: '可用'}, { id:0,value: '禁用',label: '禁用'}],
				hasMenuValidationError: false, // 新增：菜单权限校验错误标志
				roleOptions: [{
						id: 0,
						label: '测试'
					}, {
						id: 1,
						label: '普通客户'
					}, {
						id: 2,
						label: '超级用户'
					}, {
						id: 3,
						label: '管理员'
					}, {
						id: 4,
						label: '超级管理员'
					},
					{
						id: 5,
						label: '国家医保人员'
					}, {
						id: 6,
						label: '运维人员'
					}, {
						id: 7,
						label: '医生'
					}, {
						id: 8,
						label: '护士'
					}, {
						id: 9,
						label: '我是老板'
					}, {
						id: 10,
						label: '内部研发人员'
					},
				],
				// 表单校验规则
				formRules: {
				  roleName: [
				    { required: true, message: '角色名称不能为空', trigger: 'blur' },
				    { min: 2, max: 20, message: '角色名称长度在 2 到 20 个字符', trigger: 'blur' }
				  ],
				  clinicId: [],
				  menuId: []
				},
				docclinicOptions: [], // 获取诊所列表
				// header查询重置按钮（不再使用循环，但保留空数组）
				headerBtn: [],
				headerBtnbottomRight: [],
				edits: [{
					title: "详情",
					type: 'primary'
				}, {
					title: "修改",
					type: 'primary'
				}, {
					title: "分配",
					type: 'primary'
				}, {
					title: "删除",
					type: 'danger'
				}],
				// 表格行
				tableRows: [{
						name: "角色名称",
						prop: "roleName",
						type: ""
					}, {
						name: "角色ID",
						prop: "id",
						type: ""
					},
					{
						name: "角色编码",
						prop: "roleCode",
						type: ""
					}, {
						name: "描述",
						prop: "remark",
						type: ""
					},
					{
						name: "创建时间",
						prop: "createdTime",
						type: ""
					}, {
						name: '更新时间',
						prop: 'modifyTime',
						type: ''
					}
				],
				docclinicMap: {},
				// 表格data
				tableData: [],
				refundReasons: [{
						value: '用户',
						id: 1
					},
					{
						value: '护士',
						id: 2
					},
					{
						value: '医师',
						id: 3
					},
					{
						value: '药房',
						id: 4
					},
					{
						value: '管理员',
						id: 5
					},
					{
						value: '超级管理员',
						id: 6
					},
					{
						value: '其他',
						id: 7
					},
				],
				rrr: [],
				idsArray: [],
				// 新增用户
				addForm: {
					roleName: '', // 角色名称
					roleCode: '', // 角色编码
					menuId: [], // 菜单id 
					remark: '', // 备注
					clinicId: ''
				},
				// 修改表单
				editForm: {
					roleName: '', // 角色名称
					id: '', // 角色id
					roleCode: '', // 角色编码
					menuId: [], // 菜单id 
					remark: '', // 备注
					clinicId: '' // 确保包含clinicId字段
				},
			}
		},
		async mounted() {
			// 在mounted中添加获取诊所数据的调用
			await this.getClinics(); // 获取诊所列表
			await this.getcilinc();
			// await this.getAllMenus();

			this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
			this.clinicId = this.userInfo.clinicId;

			// 设置默认选中的诊所
			if (this.clinicId === 0) {
				// 如果clinicId为0，显示全部诊所选项并默认选中
				this.showAllClinicOption = true;
				this.selectedClinicId = 0;
			} else if (this.clinicOptions.length > 0) {
				// 如果clinicId不为0，默认选中当前诊所
				this.selectedClinicId = this.clinicId;
				// 检查当前诊所是否在选项中，如果不在则添加到选项
				const clinicExists = this.clinicOptions.some(item => item.id === this.clinicId);
				if (!clinicExists) {
					// 如果当前诊所不在选项中，添加到选项列表
					this.clinicOptions.push({
						id: this.clinicId,
						name: this.userInfo.clinicName || '当前诊所'
					});
				}
			}

			// 加载数据
			await this.loadData();
			await this.getInstitutionId();

			this.updateWindowWidth();
			window.addEventListener('resize', this.updateWindowWidth);
			// 初始化时获取用户菜单数据
			await this.getCurrentUserMenuData();
			this.$nextTick(() => {
				this.abc();
			});
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateWindowWidth);
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		methods: {
			/* **************************************** */
			/* 独立按钮事件方法                         */
			/* **************************************** */
			// 查询按钮独立方法
			async handleSearch() {
				try {
					this.loading = true;
					if (!this.searchValue.trim()) {
						this.searchValue = '';
						this.pageNum = 1;
						await this.loadData();
						this.$message.info('已显示所有角色数据');
						return;
					}
					let res = await getAllRole({
						roleName: this.searchValue,
						pageNum: 1,
						pageSize: this.pageSize
					});
					if (res.code === 200) {
						this.tableData = res.data.content || [];
						this.totalSize = res.data.totalSize || 0;
						if (this.tableData.length > 0) {
							this.highlightRowId = this.tableData[0].id;
							this.$message.success(`找到 ${this.tableData.length} 条与"${this.searchValue}"相关的角色数据`);
							this.$nextTick(() => {
								const table = this.$refs.table;
								if (table) {
									const row = table.$el.querySelector(`.${this.highlightClassName}`);
									if (row) row.scrollIntoView({ behavior: 'smooth', block: 'center' });
								}
							});
						} else {
							this.highlightRowId = null;
							this.$message.warning(`没有找到与"${this.searchValue}"相关的角色数据`);
						}
					} else {
						this.$message.error(res.message || '查询失败');
					}
				} catch (error) {
					console.error('查询角色出错:', error);
					this.$message.error('查询出错');
				} finally {
					this.loading = false;
				}
			},
			// 刷新按钮独立方法
			handleRefresh() {
				this.loading = true;
				setTimeout(() => {
					this.$message({ type: 'success', message: '已刷新' });
					this.loading = false;
				}, 500);
			},
			// 新增按钮独立方法（关键修复）
			async openAddRoleDialog() {
			  // 重置表单数据
			  this.addForm = {
			    roleName: '',
			    roleCode: '',
			    menuId: [],
			    remark: '',
			    clinicId: this.selectedClinicId && this.selectedClinicId !== 0 ? this.selectedClinicId : ''
			  };
			  this.hasMenuValidationError = false;
			
			  // 确保菜单数据已加载
			  if (this.MenuData.length === 0) {
			    const success = await this.getCurrentUserMenuData();
			    if (!success) {
			      this.$message.error('获取菜单数据失败');
			      return;
			    }
			  }
			
			  // 打开对话框，树的状态初始化交给 @open 事件
			  this.addRoleDialog = true;
			},
			
			// 新增方法：获取诊所列表
			async getClinics() {
				try {
					this.loading = true;
					let res = await docclinic();
					if (res.code === 200) {
						this.clinicOptions = res.data.map(item => ({
							id: item.id,
							name: item.name
						}));

						// 创建诊所映射
						this.docclinicMap = this.clinicOptions.reduce((map, item) => {
							map[item.id] = item.name;
							return map;
						}, {});

						console.log('诊所列表加载成功:', this.clinicOptions);
					} else {
						this.$message.error(res.message || '获取诊所列表失败');
					}
				} catch (error) {
					console.error('获取诊所列表失败:', error);
					this.$message.error('获取诊所列表失败');
				} finally {
					this.loading = false;
				}
			},

			// 新增方法：获取当前用户的菜单数据
			async getCurrentUserMenuData() {
				try {
					this.loading = true;

					// 调用searchUserMenu接口获取当前用户的菜单数据
					const userInfo = JSON.parse(localStorage.getItem('userInfo'));
					let uName = userInfo.username;

					let res = await searchUserMenu({
						username: uName,
					});

					console.log('searchUserMenu接口返回数据:', res);

					if (res) {
						// 处理返回的菜单数据，赋值给MenuData
						this.MenuData = this.processMenuData(res || res.data || res.rows);
						console.log('用户菜单数据加载成功:', this.MenuData);

						// 同时更新会话存储（保持兼容性）
						sessionStorage.setItem('Menus', JSON.stringify(res));
						return true;
					} else {
						console.error('获取用户菜单数据失败:', res);
						this.$message.error('获取菜单数据失败');
						return false;
					}
				} catch (error) {
					console.error('获取用户菜单数据失败:', error);
					this.$message.error('获取菜单数据失败');
					return false;
				} finally {
					this.loading = false;
				}
			},

			// 处理菜单数据
			processMenuData(menuData) {
				if (!menuData) return [];

				// 如果数据是数组，直接处理
				if (Array.isArray(menuData)) {
					return this.formatMenuData(menuData);
				}

				// 如果数据有children属性，使用children
				if (menuData.children && Array.isArray(menuData.children)) {
					return this.formatMenuData(menuData.children);
				}

				// 如果数据有rows属性，使用rows
				if (menuData.rows && Array.isArray(menuData.rows)) {
					return this.formatMenuData(menuData.rows);
				}

				// 如果数据有data属性，使用data
				if (menuData.data && Array.isArray(menuData.data)) {
					return this.formatMenuData(menuData.data);
				}

				// 尝试从对象中提取菜单数据
				const extractedData = this.extractMenuDataFromObject(menuData);
				if (extractedData.length > 0) {
					return this.formatMenuData(extractedData);
				}

				return [];
			},
			// 格式化菜单数据
			formatMenuData(menuList) {
				if (!menuList || !Array.isArray(menuList)) return [];

				return menuList.map(item => {
					if (!item) return null;

					const formattedItem = {
						id: item.id || item.menuId || Math.random().toString(36).substr(2, 9),
						label: item.label || item.name || item.title || '未命名菜单',
						children: []
					};

					// 递归处理子菜单
					if (item.children && Array.isArray(item.children)) {
						formattedItem.children = this.formatMenuData(item.children);
					} else if (item.rows && Array.isArray(item.rows)) {
						formattedItem.children = this.formatMenuData(item.rows);
					}

					return formattedItem;
				}).filter(item => item !== null);
			},

			// 从对象中提取菜单数据
			extractMenuDataFromObject(obj) {
				if (!obj || typeof obj !== 'object') return [];

				const menuItems = [];

				// 递归遍历对象，提取包含菜单信息的对象
				const extract = (currentObj) => {
					if (!currentObj) return;

					// 检查当前对象是否包含菜单信息
					if (currentObj.id && (currentObj.label || currentObj.name || currentObj.title)) {
						menuItems.push({
							id: currentObj.id,
							label: currentObj.label || currentObj.name || currentObj.title,
							children: currentObj.children || []
						});
					}

					// 递归遍历所有属性
					Object.keys(currentObj).forEach(key => {
						const value = currentObj[key];
						if (value && typeof value === 'object') {
							extract(value);
						}
					});
				};

				extract(obj);
				return menuItems;
			},

			// 获取角色菜单权限
			async getRoleMenuIds(roleId) {
				try {
					let res = await roleMenuIds({
						roleId: roleId
					});

					console.log('roleMenuIds接口返回数据:', res);

					if (res) {
						// 处理返回的菜单ID数据
						return this.processMenuIds(res);
					} else {
						console.error('获取角色菜单权限失败:', res);
						return [];
					}
				} catch (error) {
					console.error('获取角色菜单权限失败:', error);
					return [];
				}
			},

			// 处理菜单ID数据
			processMenuIds(menuIdsData) {
				if (!menuIdsData) return [];

				// 如果数据是数组，直接返回
				if (Array.isArray(menuIdsData)) {
					return menuIdsData.filter(id => id != null && id !== '');
				}

				// 如果数据是对象，尝试提取ID数组
				if (typeof menuIdsData === 'object') {
					// 尝试不同的可能属性名
					const possibleKeys = ['menuIds', 'menuIdList', 'ids', 'data', 'rows'];
					for (let key of possibleKeys) {
						if (menuIdsData[key] && Array.isArray(menuIdsData[key])) {
							return menuIdsData[key].filter(id => id != null && id !== '');
						}
					}

					// 如果对象本身包含ID字段，尝试提取所有ID值
					const ids = [];
					Object.values(menuIdsData).forEach(value => {
						if (typeof value === 'number' || (typeof value === 'string' && value !== '')) {
							ids.push(value);
						}
					});
					return ids;
				}

				return [];
			},

			// 新增方法：处理诊所选择变化
			handleClinicChange(clinicId) {
				console.log('选择的诊所ID:', clinicId);
				this.selectedClinicId = clinicId;
				// 重新加载数据
				this.loadData();
			},

			async loadData() {
				try {
					this.loading = true;

					// 构建请求参数
					const params = {
						roleName: this.searchValue || '',
						pageNum: this.pageNum,
						pageSize: this.pageSize
					};

					// 如果选择了具体诊所（非0），添加clinicId参数
					if (this.selectedClinicId && this.selectedClinicId !== 0) {
						params.clinicId = this.selectedClinicId;
					}

					let res = await getAllRole(params);

					// 明确处理响应
					if (res && res.code === 200) {
						this.tableData = res.data.content || [];
						this.totalSize = res.data.totalSize || 0;

						// 确保默认选中第一行（如果需要）
						if (this.tableData.length > 0) {
							this.highlightRowId = this.tableData[0].id;
						}
					} else {
						const errorMsg = res ? (res.message || '加载数据失败') : '请求失败';
						this.$message.error(errorMsg);
						this.tableData = [];
						this.totalSize = 0;
					}
				} catch (error) {
					console.error('加载数据出错:', error);
					this.$message.error('加载数据出错');
					this.tableData = [];
					this.totalSize = 0;
				} finally {
					this.loading = false;
				}
			},

			async getcilinc() {
				// 所有菜单
				let res = await docclinic();
				this.docclinicOptions = res.data.map(v => {
					return {
						label: v.name,
						...v
					}
				});
				// 将 民族 转换为 minZuMap 格式
				this.docclinicMap = this.docclinicOptions.reduce((map, item) => {
					map[item.id] = item.label; // 使用 id 作为键，label 作为值
					return map;
				}, {
					1: '数据不对，默认null'
				}); // 保留初始值
			},
			async abc() {
				let resp = await roleList({
					clinicId: this.clinicId, // 现在有值了
				});
			},
			async getsearchUserMenu() {
				try {
					this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
					let uName = this.userInfo.username;

					// 获取用户菜单
					let res = await searchUserMenu({
						username: uName,
					});
					console.log(res, 'lllllllllllllllllllllllll');
					// 更新本地存储中的Menus
					sessionStorage.setItem('Menus', JSON.stringify(res));
					console.log('用户菜单已更新到本地存储');
				} catch (error) {
					console.error('获取用户菜单失败:', error);
				}
			},
			// 获取赋值隶属机构
			async getInstitutionId() {
				let res = await docclinic();
				this.clincOptions = res.data.map(v => {
					return {
						label: v.name,
						...v
					}
				});
			},
			/* about tree */
			handleNodeClick(data, e) {
				this.CatalogueName = data.title
				this.iconComes = 'el-icon-' + this.makePy(data.label)
				console.log(this.iconComes);
			},

			// 新增方法：判断节点是否为子节点（有父节点）
			isChildNode(node) {
				if (!node || !this.MenuData || this.MenuData.length === 0) return false;

				// 递归查找节点是否有父节点
				const findParent = (nodes, targetId, parent = null) => {
					for (const item of nodes) {
						if (item.id === targetId) {
							return parent !== null; // 如果有父节点，说明是子节点
						}
						if (item.children && item.children.length > 0) {
							const found = findParent(item.children, targetId, item);
							if (found) return true;
						}
					}
					return false;
				};

				return findParent(this.MenuData, node.id);
			},
			
			// 递归勾选所有子节点
			checkAllChildren(node) {
			  const tree = this.$refs.tree;
			  if (!tree || !node) return;
			  if (node.children && node.children.length) {
			    node.children.forEach(child => {
			      if (!tree.getCheckedKeys().includes(child.id)) {
			        tree.setChecked(child.id, true, false);
			      }
			      this.checkAllChildren(child);
			    });
			  }
			},
			
			// 递归取消勾选所有子节点
			uncheckAllChildren(node) {
			  const tree = this.$refs.tree;
			  if (!tree || !node) return;
			  if (node.children && node.children.length) {
			    node.children.forEach(child => {
			      if (tree.getCheckedKeys().includes(child.id)) {
			        tree.setChecked(child.id, false, false);
			      }
			      this.uncheckAllChildren(child);
			    });
			  }
			},

			// 检查是否有当前角色
			checkYNRole() {
				// 创建一个 Set 来存储 选择框中 已有的 name
				let namesInB = JSON.parse(localStorage.getItem('userInfo')).roleName
				// 遍历 elMenusOption，判断是否有相同的 name，并新增字段
				this.roleOptions = this.roleOptions.map(item => {
					if (item.label == namesInB) {
						return {
							...item,
							disabled: true
						};
					}
					return item;
				});
			},
			
			tableRowClassName({
				row
			}) {
				return row.id === this.highlightRowId ? this.highlightClassName : '';
			},
			
			// 新增角色对话框打开时执行（核心修复：确保工作台及其子节点被正确勾选）
			handleAddDialogOpen() {
			  this.hasMenuValidationError = false;
			  
			  // 等待树组件完全渲染后再操作
			  this.$nextTick(() => {
			    const tree = this.$refs.tree;
			    if (!tree) {
			      console.warn('树组件未就绪');
			      return;
			    }
			    
			    // 先清空所有勾选
			    tree.setCheckedKeys([]);
			    
			    // 查找工作台节点
			    const dashboardNode = this.findDashboardNode(this.MenuData);
			    if (dashboardNode) {
			      // 获取工作台及其所有后代节点的ID
			      const dashboardIds = this.getDashboardAndChildrenIds(dashboardNode);
			      if (dashboardIds.length) {
			        // 设置勾选，并强制刷新
			        tree.setCheckedKeys(dashboardIds);
			        this.addForm.menuId = dashboardIds;
			        console.log('新增模式：已勾选工作台及其子节点', dashboardIds);
			      } else {
			        console.warn('工作台节点无有效ID');
			      }
			    } else {
			      console.warn('未找到工作台节点，请检查菜单数据中的label是否包含"工作台"');
			    }
			    
			    // 清除表单验证
			    if (this.$refs.addForm) {
			      this.$refs.addForm.clearValidate();
			    }
			  });
			},
			
			// 修改角色对话框打开时执行
			handleEditDialogOpen() {
			  this.hasMenuValidationError = false;
			  
			  this.$nextTick(() => {
			    const tree = this.$refs.tree;
			    if (!tree) return;
			    
			    // 先清空所有勾选
			    tree.setCheckedKeys([]);
			    
			    // 设置该角色已有的菜单权限 + 工作台强制勾选
			    const dashboardNode = this.findDashboardNode(this.MenuData);
			    let allMenuIds = [...this.editRoleMenuIds];
			    if (dashboardNode) {
			      const dashboardIds = this.getDashboardAndChildrenIds(dashboardNode);
			      // 合并去重
			      allMenuIds = [...new Set([...allMenuIds, ...dashboardIds])];
			    }
			    
			    tree.setCheckedKeys(allMenuIds);
			    this.editForm.menuId = allMenuIds;
			    console.log('编辑模式：已勾选角色权限+工作台', allMenuIds);
			  });
			},
			
			// 处理编辑对话框，确保工作台默认选中且不可取消,修复handleEdit方法中的clinicId赋值错误
			async handleEdit(row) {
			  this.currentEditId = row.id;
			  this.editForm = {
			    ...row,
			    clinicId: row.clinicId || this.selectedClinicId || ''
			  };
			
			  // 获取该角色的菜单权限ID，存储到临时变量
			  if (this.MenuData.length === 0) {
			    const success = await this.getCurrentUserMenuData();
			    if (!success) {
			      this.$message.error('获取菜单数据失败');
			      return;
			    }
			  }
			  const roleMenuIds = await this.getRoleMenuIds(row.id);
			  this.editRoleMenuIds = roleMenuIds;  // 保存，供 @open 使用
			
			  // 打开对话框
			  this.editRoleDialog = true;
			},

			// 处理复选框变化事件（实现：勾选子节点时自动勾选父节点，取消时强制保持父节点及所有祖先节点为完全勾选）
			// 处理复选框变化（完全自定义父子联动）
			handleCheckChange(data, { checkedNodes, checkedKeys }) {
			  const tree = this.$refs.tree;
			  if (!tree) return;
			
			  // 工作台强制勾选（不可取消）
			  const isDashboard = this.isDashboardNode(data);
			  if (isDashboard && !tree.getCheckedKeys().includes(data.id)) {
			    tree.setChecked(data.id, true, false);
			    this.$message.warning('工作台权限为必选，不可取消');
			    return;
			  }
			
			  const currentChecked = tree.getCheckedKeys();
			  const wasChecked = currentChecked.includes(data.id);
			
			  if (wasChecked) {
			    // ===== 勾选操作 =====
			    // 1. 如果是父节点（有子节点），递归勾选所有子节点
			    if (data.children && data.children.length > 0) {
			      this.checkAllChildren(data);
			    }
			    // 2. 向上递归勾选所有祖先节点
			    let parent = this.findParentNode(this.MenuData, data.id);
			    while (parent) {
			      if (!tree.getCheckedKeys().includes(parent.id)) {
			        tree.setChecked(parent.id, true, false);
			      }
			      parent = this.findParentNode(this.MenuData, parent.id);
			    }
			  } else {
			    // ===== 取消操作 =====
			    // 只取消当前节点，然后强制所有祖先节点保持完全勾选（√）
			    // 使用多个延时确保覆盖 el-tree 的异步状态更新
			    const ancestors = [];
			    let parent = this.findParentNode(this.MenuData, data.id);
			    while (parent) {
			      ancestors.push(parent);
			      parent = this.findParentNode(this.MenuData, parent.id);
			    }
			    if (ancestors.length > 0) {
			      const setAncestorsChecked = () => {
			        ancestors.reverse().forEach(anc => {
			          if (!tree.getCheckedKeys().includes(anc.id)) {
			            tree.setChecked(anc.id, true, false);
			          }
			        });
			      };
			      // 立即执行一次
			      setAncestorsChecked();
			      // 延迟多次执行，防止 el-tree 后续覆盖
			      setTimeout(setAncestorsChecked, 50);
			      setTimeout(setAncestorsChecked, 150);
			    }
			  }
			
			  // 更新表单中的 menuId（此时 tree.getCheckedKeys() 只包含用户实际勾选的节点）
			  const finalCheckedKeys = tree.getCheckedKeys();
			  if (this.editRoleDialog) {
			    this.editForm.menuId = finalCheckedKeys;
			  }
			  if (this.addRoleDialog) {
			    this.addForm.menuId = finalCheckedKeys;
			  }
			
			  this.hasMenuValidationError = finalCheckedKeys.length === 0;
			},
			
			// 新增：强制保持所有祖先节点为完全勾选状态（递归直到稳定）
			forceKeepAncestorsChecked(nodeId) {
			  const tree = this.$refs.tree;
			  if (!tree) return;
			
			  const collectAncestors = (id, ancestors = []) => {
			    const parent = this.findParentNode(this.MenuData, id);
			    if (parent) {
			      ancestors.push(parent);
			      collectAncestors(parent.id, ancestors);
			    }
			    return ancestors;
			  };
			
			  const ancestors = collectAncestors(nodeId);
			  if (ancestors.length === 0) return;
			
			  // 从最顶层祖先开始强制设置为勾选
			  const setCheckedRecursive = () => {
			    let changed = false;
			    ancestors.reverse().forEach(anc => {
			      if (!tree.getCheckedKeys().includes(anc.id)) {
			        tree.setChecked(anc.id, true, false);
			        changed = true;
			      }
			    });
			    // 如果本次有变更，可能存在 el-tree 再次覆盖的情况，再延迟执行一次确保稳定
			    if (changed) {
			      setTimeout(() => {
			        ancestors.reverse().forEach(anc => {
			          if (!tree.getCheckedKeys().includes(anc.id)) {
			            tree.setChecked(anc.id, true, false);
			          }
			        });
			      }, 50);
			    }
			  };
			
			  // 使用 setTimeout 延迟执行，确保 el-tree 的默认半选逻辑已经完成
			  setTimeout(setCheckedRecursive, 20);
			},
			
			// 重置菜单树的勾选状态
			resetTreeState() {
			    if (this.$refs.tree) {
			      // 清除所有勾选
			      this.$refs.tree.setCheckedKeys([]);
			      // 重置默认勾选数组
			      this.defaultCheckedKeys = [];
			      // 清除菜单权限校验错误标志
			      this.hasMenuValidationError = false;
			    }
			},
			  
			// 新增方法：判断节点是否为工作台节点
			isDashboardNode(node) {
				if (!node) return false;
				const nodeName = (node.label || node.name || node.title || '').toLowerCase().trim();
				return nodeName === '工作台' || nodeName === 'dashboard' || nodeName.includes('工作台');
			},

			// 更新父节点的半选状态
			updateParentIndeterminate(node) {
			  const tree = this.$refs.tree;
			  if (!tree || !node) return;
			
			  const parentNode = this.findParentNode(this.MenuData, node.id);
			  if (parentNode) {
			    // 获取父节点下所有子节点（包括当前节点）的勾选状态
			    const childrenChecked = this.getChildrenCheckStatus(parentNode);
			    if (childrenChecked.some(checked => checked === true)) {
			      // 如果有任意子节点被勾选，父节点应该被勾选
			      if (!tree.getCheckedKeys().includes(parentNode.id)) {
			        tree.setChecked(parentNode.id, true, false);
			      }
			    } else {
			      // 所有子节点都未勾选，父节点取消勾选
			      if (tree.getCheckedKeys().includes(parentNode.id)) {
			        tree.setChecked(parentNode.id, false, false);
			      }
			    }
			    // 递归向上更新
			    this.updateParentIndeterminate(parentNode);
			  }
			},
			
			// 获取某个节点下所有直接子节点的勾选状态数组
			getChildrenCheckStatus(parentNode) {
			  const tree = this.$refs.tree;
			  if (!tree || !parentNode.children) return [];
			  return parentNode.children.map(child => tree.getCheckedKeys().includes(child.id));
			},
			
			// 递归查找父节点
			findParentNode(nodes, childId, parent = null) {
				for (const node of nodes) {
					if (node.id === childId) {
						return parent;
					}
					if (node.children && node.children.length > 0) {
						const found = this.findParentNode(node.children, childId, node);
						if (found) return found;
					}
				}
				return null;
			},
			
			// 勾选所有父节点
			checkParentNodes(node) {
			  const tree = this.$refs.tree;
			  if (!tree || !node) return;
			
			  const parentNode = this.findParentNode(this.MenuData, node.id);
			  if (parentNode) {
			    if (!tree.getCheckedKeys().includes(parentNode.id)) {
			      tree.setChecked(parentNode.id, true, false);
			    }
			    this.checkParentNodes(parentNode);
			  }
			},

			// 修改列宽计算方法，增加响应式处理
			columnWidth(col, list) {
				if (!list || list.length === 0) return 120;

				let prop = col.prop;
				let lab = col.name;
				let width = 100; // 基础宽度

				// 根据窗口宽度调整基础宽度
				const screenWidth = this.windowWidth || window.innerWidth;
				if (screenWidth < 1366) {
					width = 80; // 小屏幕使用较小宽度
				}

				let maxlenStr = "";
				for (let info of list) {
					if (info[prop] && (info[prop] + "").length > maxlenStr.length) {
						maxlenStr = info[prop] + "";
					}
				}

				// 计算内容宽度
				const contentWidth = Math.max(this.calcTextWidth(lab), this.calcTextWidth(maxlenStr));

				// 返回合适的宽度
				return Math.max(width, contentWidth + 24);
			},

			// 计算文本宽度
			calcTextWidth(str) {
				if (!str) return 0;
				let length = 0;
				for (const char of str) {
					if (char >= "\u4e00" && char <= "\u9fa5") {
						length += 16; // 中文字符宽度
					} else {
						length += 8; // 英文字符宽度
					}
				}
				return length;
			},

			// 删除角色
			handleDelete(id) {
				this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(async () => {
						this.loading = true;
						try {
							const result = await deleteRole({
								roleId: id
							});
							if (result.code === 200) {
								this.$message.success(result.message);
								this.loadData(); // 刷新列表
							} else {
								this.$message.error(result.message || '删除失败');
							}
						} catch (error) {
							console.error('删除出错:', error);
							this.$message.error('删除操作出错');
						} finally {
							this.loading = false;
						}
					})
					.catch(() => {
						this.$message.info('已取消删除');
					});
			},
			
			// 编辑角色提交
			async editSubmit() {
				try {
					this.editLoading = true;
					const currentCheckedKeys = this.$refs.tree.getCheckedKeys();
					this.editForm.menuId = currentCheckedKeys;
					const userInfo = JSON.parse(localStorage.getItem('userInfo'));
					const currentUserClinicId = userInfo.clinicId;
					if (currentUserClinicId === 0) {
						this.editForm.clinicId = this.editForm.clinicId || this.selectedClinicId;
					} else {
						this.editForm.clinicId = currentUserClinicId;
					}
					let res = await editRole(this.editForm);
					if (res && res.code === 200) {
						this.$message.success(res.message || '角色修改成功');
						await this.getsearchUserMenu();
						EventBus.$emit('update-menu');
						this.editRoleDialog = false;
						await this.loadData();
						return;
					} else {
						this.$message.error(res ? (res.message || '修改失败') : '请求失败');
						return;
					}
				} catch (error) {
					console.error('编辑角色失败:', error);
					if (error.response) {
						this.$message.error(`网络错误: ${error.response.status}`);
					} else if (error.request) {
						this.$message.error('网络连接失败，请检查网络设置');
					} else {
						this.$message.error(error.message || '编辑角色失败');
					}
				} finally {
					this.editLoading = false;
				}
			},

			// 新增角色提交（关键修改：移除自动生成角色编码逻辑）
			async addSubmit() {
			  try {
			    this.addLoading = true;
			    const currentCheckedKeys = this.$refs.tree.getCheckedKeys();
			    this.addForm.menuId = currentCheckedKeys;
			    
			    // 自动生成角色编码（基于角色名称）
			    if (!this.addForm.roleName) {
			      this.$message.error('角色名称不能为空');
			      this.addLoading = false;
			      return;
			    }
			    // 生成规则：角色名称（去空格）+ 下划线 + 时间戳 + 随机字符串
			    this.addForm.roleCode = Date.now().toString();
			    
			    // 诊所ID处理（保持不变）
			    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
			    const currentUserClinicId = userInfo.clinicId;
			    if (currentUserClinicId === 0) {
			      this.addForm.clinicId = this.addForm.clinicId || this.selectedClinicId;
			    } else {
			      this.addForm.clinicId = currentUserClinicId;
			    }
			    
			    this.$refs.addForm.validate(async (valid) => {
			      if (!valid) {
			        this.addLoading = false;
			        return;
			      }
			      const res = await addRole(this.addForm);
			      if (res.code === 200) {
			        this.$message.success(res.message);
			        const menuRes = await AllMenu();
			        if (menuRes.code === 200) {
			          sessionStorage.setItem('MenuForRoleItems', JSON.stringify(menuRes.data));
			        }
			        this.loadData();
			        this.addRoleDialog = false;
			        await this.getsearchUserMenu();
			        EventBus.$emit('update-menu');
			      } else {
			        this.$message.error(res.message);
			      }
			      this.addLoading = false;
			    });
			  } catch (error) {
			    console.error('新增角色失败:', error);
			    this.addLoading = false;
			    this.$message.error('新增角色失败');
			  }
			},
			
			// 获取动态校验规则
			getDynamicRules() {
			    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
			    const currentUserClinicId = userInfo.clinicId;
			    
			    // 动态设置诊所校验规则
			    const clinicRules = [];
			    if (currentUserClinicId === 0) {
			      clinicRules.push({ 
			        required: true, 
			        message: '请选择诊所', 
			        trigger: 'change' 
			      });
			    }
			    
			    // 菜单权限校验规则
			    const menuRules = [
			      { 
			        validator: this.validateMenuSelection, 
			        trigger: 'change' 
			      }
			    ];
			    
			    return {
			      clinicId: clinicRules,
			      menuId: menuRules
			    };
			},
			  
			// 自定义菜单选择校验
			validateMenuSelection(rule, value, callback) {
			    const tree = this.$refs.tree;
			    if (!tree) {
			      callback(new Error('菜单组件未加载'));
			      return;
			    }
			    
			    const checkedKeys = tree.getCheckedKeys();
			    if (!checkedKeys || checkedKeys.length === 0) {
			      callback(new Error('请至少选择一个菜单权限'));
			    } else {
			      callback();
			    }
			},
			  
			// 获取完整的表单规则
			getFormRules() {
			    const dynamicRules = this.getDynamicRules();
			    return {
			      roleName: this.formRules.roleName,
			      clinicId: dynamicRules.clinicId,
			      menuId: dynamicRules.menuId
			    };
			},
			  
			// 验证菜单权限选择
			validateMenuPermissions() {
			    const tree = this.$refs.tree;
			    if (!tree) {
			      this.$message.error('菜单组件未加载');
			      return false;
			    }
			    
			    const checkedKeys = tree.getCheckedKeys();
			    if (!checkedKeys || checkedKeys.length === 0) {
			      this.$message.error('请至少选择一个菜单权限');
			      return false;
			    }
			    
			    return true;
			},
			
			// 查找工作台节点
			findDashboardNode(menuData) {
				if (!menuData || !Array.isArray(menuData)) return null;

				const findDashboard = (nodes) => {
					for (const node of nodes) {
						const nodeName = (node.label || node.name || node.title || '').toLowerCase().trim();
						if (nodeName === '工作台' || nodeName === 'dashboard' || nodeName.includes('工作台')) {
							return node;
						}
						if (node.children && node.children.length > 0) {
							const found = findDashboard(node.children);
							if (found) return found;
						}
					}
					return null;
				};

				return findDashboard(menuData);
			},
			
			// 获取工作台节点及其所有子节点的ID
			getDashboardAndChildrenIds(dashboardNode) {
				const ids = [];
				if (!dashboardNode) return ids;

				const collectIds = (node) => {
					if (node.id) {
						ids.push(node.id);
					}
					if (node.children && node.children.length > 0) {
						node.children.forEach(child => collectIds(child));
					}
				};

				collectIds(dashboardNode);
				return ids;
			},
			
			// 表格行双击
			handledbRow(row, column, event) {
				console.log(row);
			},
			
			// 分页
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageNum = val;
				this.loadData();
			},
			
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
				this.loadData();
			},
			
			// 关闭对话框
			handleClose(done) {
			  // 重置表单数据（仅重置表单，不影响树）
			  if (this.$refs.addForm) {
			    this.$refs.addForm.resetFields();
			  }
			  if (this.$refs.form) {
			    this.$refs.form.resetFields();
			  }
			
			  // 注意：不要在这里重置树状态，留给 @open 事件处理
			
			  this.$nextTick(() => {
			    if (done) {
			      done();
			    } else {
			      this.addRoleDialog = false;
			      this.editRoleDialog = false;
			    }
			  });
			},
			
			// 重置表单（保留）
			resetForm() {
				this.$refs.addForm.resetFields();
			},
			
			// 更新窗口宽度
			updateWindowWidth() {
				this.windowWidth = window.innerWidth;
				if (this.$refs.table) {
					this.$refs.table.doLayout();
				}
			},
			
			// 递归提取所有id
			extractIds(data) {
				const ids = [];
				function traverse(node) {
					if (node.id) {
						ids.push(node.id);
					}
					if (node.children && node.children.length > 0) {
						node.children.forEach(child => {
							traverse(child);
						});
					}
				}
				data.forEach(node => {
					traverse(node);
				});
				return ids;
			},
			
			// 递归替换key
			replaceKey(obj) {
				if (Array.isArray(obj)) {
					return obj.map(item => this.replaceKey(item));
				} else if (typeof obj === 'object' && obj !== null) {
					const newObj = { ...obj };
					if (newObj.name !== undefined) {
						newObj.label = newObj.name;
						delete newObj.name;
					}
					for (const key in newObj) {
						if (typeof newObj[key] === 'object' && newObj[key] !== null) {
							newObj[key] = this.replaceKey(newObj[key]);
						}
					}
					return newObj;
				} else {
					return obj;
				}
			},
		},
		watch: {
			windowWidth(newVal) {
				console.log('New window width:', newVal);
			}
		}
	}
</script>

<style lang="less" scoped>
	.user-container {
		width: 100%;
		height: 100%;
		background-color: #f5f7fa;
		box-sizing: border-box;

		.content-main {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			background: #fff;
			border-radius: 12px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
			overflow: hidden;

			.title {
				height: 56px;
				line-height: 56px;
				padding: 0 24px;
				border-bottom: 1px solid #edf2f7;
				background: #fff;
				span {
					font-weight: 600;
					font-size: 18px;
					color: #1e293b;
					letter-spacing: 0.5px;
				}
			}

			.main {
				flex: 1;
				display: flex;
				overflow: hidden;

				.main-right {
					flex: 1;
					display: flex;
					flex-direction: column;
					padding: 20px 24px;
					overflow: hidden;

					.search-container {
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-bottom: 20px;
						flex-wrap: wrap;
						gap: 12px;

						.left-buttons {
							display: flex;
							align-items: center;
							flex-wrap: wrap;
							gap: 12px;

							/deep/ .el-input {
								width: 200px;
							}
						}

						.right-buttons {
							display: flex;
							gap: 12px;
						}
					}

					.table-container {
						flex: 1;
						overflow: hidden;
						border: 1px solid #eef2f6;
						border-radius: 12px;

						/deep/ .el-table {
							height: 100%;
							--el-table-border-color: #eef2f6;

							th {
								background-color: #f8fafc !important;
								font-weight: 600;
								color: #334155;
							}

							.el-table__body-wrapper {
								overflow-x: auto;
							}

							.cell {
								font-size: 13px;
								text-align: center;
							}

							td {
								padding: 8px 0 !important;
							}

							.highlight-row {
								background-color: #f0fdf4 !important;
							}
						}
					}

					.pagination-container {
						margin-top: 20px;
						display: flex;
						justify-content: flex-end;
					}
				}
			}
		}
	}

	/* 弹窗样式美化 */
	.beauty-role-dialog {
		/deep/ .el-dialog {
			border-radius: 20px;
			box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.2);
			overflow: hidden;
			
			.el-dialog__header {
				padding: 20px 24px 12px;
				border-bottom: 1px solid #f0f2f5;
				background: #fff;
				
				.el-dialog__title {
					font-size: 18px;
					font-weight: 600;
					color: #1f2f3d;
				}
			}
			
			.el-dialog__body {
				padding: 24px 28px;
				max-height: 70vh;
				overflow-y: auto;
			}
			
			.el-dialog__footer {
				padding: 16px 24px 24px;
				border-top: 1px solid #f0f2f5;
				text-align: right;
			}
		}
		
		.el-form-item__label {
			font-weight: 500;
			color: #334155;
		}
		
		.menu-tree-wrapper {
			border: 1px solid #e2e8f0;
			border-radius: 12px;
			padding: 12px;
			background: #fefefe;
			transition: all 0.2s;
			
			.menu-tree {
				max-height: 320px;
				overflow-y: auto;
				
				/deep/ .el-tree-node__content {
					height: 36px;
					&:hover {
						background-color: #f1f5f9;
					}
				}
			}
			
			.menu-error-msg {
				color: #f56c6c;
				font-size: 12px;
				margin-top: 8px;
				padding-left: 8px;
			}
		}
	}

	@media screen and (max-width: 1366px) {
		.user-container {
			padding: 0 8px;

			.content-main .main .main-right {
				padding: 12px;

				.search-container {
					flex-direction: column;
					align-items: flex-start;

					.left-buttons,
					.right-buttons {
						width: 100%;
						justify-content: flex-start;
					}
				}
			}
		}

		.beauty-role-dialog {
			/deep/ .el-dialog {
				width: 90% !important;
			}
		}
	}

	@media screen and (max-width: 768px) {
		.search-container {
			flex-direction: column;
			align-items: stretch;

			.left-buttons /deep/ .el-input {
				width: 100% !important;
				margin-bottom: 8px;
			}
		}
	}
</style>